export default function FreezeIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1798 13.03L16.8499 13.65L16.4599 13.44V10.56L16.8499 10.3L19.1798 10.92L19.6998 8.99L17.9299 8.52L18.3899 6.75L16.4599 6.23L15.8399 8.56L15.4499 8.82L12.9999 7.38V7.12L14.7099 5.41L13.2899 4L11.9999 5.29L10.7099 4L9.28985 5.41L10.9999 7.12V7.38L8.49985 8.82L8.12986 8.56L7.54986 6.23L5.62986 6.75L6.09986 8.52L4.32986 8.99L4.84986 10.92L7.17986 10.3L7.54985 10.56V13.45L7.27985 13.7472L4.94985 13.1272L4.42985 15.0572L6.19985 15.5272L5.72985 17.2872L7.65985 17.8072L8.27985 15.4772L8.54985 15.18L10.9999 16.62V16.88L9.28985 18.59L10.7099 20L11.9999 18.71L13.2899 20L14.6999 18.59L12.9999 16.88V16.62L15.4999 15.17L15.8899 15.38L16.5099 17.71L18.3899 17.2L17.9199 15.43L19.6898 14.96L19.1798 13.03ZM9.49985 10.56L11.9999 9.11L14.4999 10.56V13.44L11.9999 14.89L9.49985 13.44V10.56Z"
        fill="#3C3C3C"
      />
    </svg>
  );
}
